import Vue from 'vue';
import Vuex from 'vuex';
import security from "./modules/security.js";
import product from "./modules/product.js";
import brand from "./modules/brand.js"
import user from "./modules/user.js";
import bookmark from "./modules/bookmark.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    security,
    product,
    brand,
    user,
    bookmark
  }
});
